import { EVENTS, FolderTypes } from '@DavisDigital/interfaces';

declare var hibachiConfig;
declare var angular;

class ImportLessonContentModalController {
	
	public contentModule:any; 
	public currentPage:number;
	public keywords:string;
	
	public isLoading:boolean;
	public pageShow:number = 6;
	
	public portfolioPage;
	public portfolioPageId : string;

	public position;
	
	public saveEvent = 'importLessonContentSave';
	public selectedLessonId; 
	
	public totalPages:number; 
	
	public records:any[];
	
	private previouslyFocusedElement: HTMLElement | null = null;
	private focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

	// @ngInject
	constructor(
		public $filter,
		public $timeout,
		public $element,
		public contentService, 
		public imageService,
		public ModalService,
		public observerService,
		public portfolioService,
		private apiService
	){}
	
	public $onInit = () => {
		// Store the element that had focus before the modal opened
		this.previouslyFocusedElement = document.activeElement as HTMLElement;

		this.observerService.attach(this.save, this.saveEvent);
		this.search(1);

		// Set initial focus to the close button after render
		this.$timeout(() => {
			const modalEl = this.$element[0].querySelector('.modal');
			if (modalEl) {
				modalEl.removeAttribute('aria-hidden');
				const closeBtn = modalEl.querySelector('.close') as HTMLElement;
				if (closeBtn) {
					closeBtn.focus();
				}
			}
		});
	}
	
	public keywordSearch(){
		this.search(1);
	}
	
	public search = ( pageNumber?:number) =>{
		this.isLoading = true;
		
		if(pageNumber){
			this.currentPage = pageNumber;
		}
		var args:any = {
			currentPage:this.currentPage,
			pageShow:this.pageShow
		};

		if(this.keywords?.length){
			args.keywords = this.keywords;
		}
		
		this.apiService.request('davisdigital:api.getAllOfMyLessons',args)
		.then( (response)=>{
			if(response.data?.data){
				let result = response.data.data;
				this.totalPages = result.totalPages;
				
				for(var i=0; i < result.records.length; i++){
					result.records[i]['createdDateTime'] = this.$filter('date')( new Date( result.records[i]['createdDateTime'] ), "'Created on ' MM/dd/yyyy" )
				}
				
				this.records = result.records;
				this.isLoading = false;
			}
		});
	}
	
	public save = (args:any) =>{
		
		this.isLoading = true; 
		
		if(args.lessonID != null){
			this.selectedLessonId = args.lessonID
		}
		
		if(args.portfolioPageID){
			this.portfolioPageId = args.portfolioPageID;
		}
		
		if(this.portfolioPageId?.length !== 32){
			return this.portfolioService.getMyPortfolioFolders({ showAll: true })
	    	.then((result) => {
	    		this.isLoading = false;
	    		
	    		let allFolders = result.data.records;
	    		
	    		this.ModalService.showModal({
	    			component: 'saveAsModal',
	    			bodyClass: 'angular-modal-service-active',
	    			bindings: {
	    				type: FolderTypes.Portfolio,
	    				folders: allFolders,
	    				portfolioPage: this.portfolioPage,
	    				saveEvent: this.saveEvent
	    			},
	    			preClose: (modal) => {
	    				modal.element.modal('hide');
	    			}
	    		}).then((modal) => {
	    			//it's a bootstrap element, use 'modal' to show it
	    			modal.element.modal('show');
	    			modal.close.then((result) => {});
	    		});
	    	});
		}
		
		var data = {
			lessonID : this.selectedLessonId,
			portfolioPageID : this.portfolioPageId
		}
		


		this.apiService.request('davisdigital:api.importLessonContentModulesToPortfolioPage', data).then( (response)=>{
			
			if(response.data?.data?.portfolioPage){
				this.observerService.notifyById(EVENTS.SET_PORTFOLIO_PAGE, response.data.data.portfolioPage.portfolioPageID, response.data.data.portfolioPage);
			}
			
		}).finally(()=>{
			this.isLoading = false; 
			this.close();
		});

	}
	
	public handleKeydown = (event: KeyboardEvent) => {
		if (event.key === 'Escape' || event.keyCode === 27) {
			event.preventDefault();
			this.close();
		}

		if (event.key === 'Tab' || event.keyCode === 9) {
			this.trapFocus(event);
		}
	}

	private trapFocus = (event: KeyboardEvent) => {
		const modalEl = this.$element[0].querySelector('.modal');
		if (!modalEl) return;

		const focusableElements = modalEl.querySelectorAll(this.focusableSelector);
		if (focusableElements.length === 0) return;

		const firstFocusable = focusableElements[0] as HTMLElement;
		const lastFocusable = focusableElements[focusableElements.length - 1] as HTMLElement;

		if (event.shiftKey) {
			if (document.activeElement === firstFocusable) {
				event.preventDefault();
				lastFocusable.focus();
			}
		} else {
			if (document.activeElement === lastFocusable) {
				event.preventDefault();
				firstFocusable.focus();
			}
		}
	}

	public close = () =>{
		this.ModalService.closeModals();

		// Restore focus to the previously focused element
		if (this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
			this.previouslyFocusedElement.focus();
		}
	}

}

class ImportLessonContentModal {
	public restrict: string = 'E';
	public templateUrl: string;
	public scope: boolean = true;
	
	public bindToController: any = {
		type:'=',
		contentModule:'=?',
		lesson:'=?',
		lessonId:'=?',
		portfolioPageId:'=?',
		portfolioPage:'=?',
		position:'='
	};

	public controller = ImportLessonContentModalController;
	public controllerAs = 'importLessonContentModal';

	public static Factory() {
		var directive:any = ( davisFrontendBasePath ) => new this( davisFrontendBasePath );
		directive.$inject = ['davisFrontendBasePath'];
		return directive;
	}

	constructor(
		private davisFrontendBasePath
	) {
		this.templateUrl = davisFrontendBasePath + '/davisdigital/directives/import-lesson-content-modal.html';
	}
}

export { ImportLessonContentModal };
